module.exports = __webpack_public_path__ + "static/img/wxcode.6e22990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wxcode.png
// module id = XTwc
// module chunks = 92